import { useCssVars as _useCssVars, defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "mobile-header" }
const _hoisted_2 = { class: "brand" }
const _hoisted_3 = ["src"]
const _hoisted_4 = { class: "user" }
const _hoisted_5 = {
  key: 0,
  class: "box-menu"
}
const _hoisted_6 = { class: "menu-content" }

import { computed, ref } from "vue";
import { svgIcon } from "@/common/components";
import { useI18n } from "vue-i18n";
import { useRouter } from "vue-router";
import store from "@/store";

import { removeUser } from "@/common/services/user";

import { baseAvatarUser } from "@/common/components";


export default /*@__PURE__*/_defineComponent({
  __name: 'mobile-header',
  props: {
    height: { default: "4rem" },
    background: { default: "#fff" }
  },
  setup(__props: any) {

_useCssVars(_ctx => ({
  "v5f39311a": (_ctx.height),
  "v2691c3a1": (_ctx.background)
}))

const { t, tm } = useI18n();
const router = useRouter();



const showMenu = ref(false);

const types = computed(() => tm("technical.types") as Record<string, string>);

const type = computed(() =>
	store.getters.type ? types.value[store.getters.type] : "",
);

function goTo(url: string) {
	showMenu.value = false;
	router.push(url);
}

function logout() {
	removeUser();
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("header", _hoisted_1, [
    _createElementVNode("section", _hoisted_2, [
      _createElementVNode("img", {
        src: require('@/assets/images/logo.png')
      }, null, 8, _hoisted_3)
    ]),
    _createElementVNode("section", _hoisted_4, [
      _createVNode(_unref(baseAvatarUser), {
        width: "11rem",
        size: "2.2rem",
        "font-size": "0.75rem",
        name: _ctx.$store.getters.profile?.first_name,
        role: type.value,
        open: showMenu.value,
        onClick: _cache[0] || (_cache[0] = ($event: any) => (showMenu.value = !showMenu.value))
      }, null, 8, ["name", "role", "open"])
    ]),
    (showMenu.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
          _createElementVNode("div", _hoisted_6, [
            _createElementVNode("div", {
              class: "item",
              onClick: _cache[1] || (_cache[1] = ($event: any) => (logout()))
            }, [
              _createVNode(_unref(svgIcon), {
                icon: "exit",
                size: "1.75rem"
              }),
              _createTextVNode(" " + _toDisplayString(_unref(t)("common.labels.exit")), 1)
            ])
          ])
        ]))
      : _createCommentVNode("", true)
  ]))
}
}

})